import { render, staticRenderFns } from "./ListaDevoluciones.vue?vue&type=template&id=e44c840c&scoped=true"
import script from "./ListaDevoluciones.vue?vue&type=script&lang=js"
export * from "./ListaDevoluciones.vue?vue&type=script&lang=js"
import style0 from "./ListaDevoluciones.vue?vue&type=style&index=0&id=e44c840c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44c840c",
  null
  
)

export default component.exports